<template>
  <div>
    <VCDataTable v-bind="dtable" @e-row-action="eRowAction">
      <template v-slot:table_col_walletBalance="scope">
        <span v-if="scope.row.wallet.balance > 0">
          <vi-amount
            color="success"
            :prefix="scope.row.wallet.currency.prefix"
            v-model="scope.row.wallet.balance"
          />
        </span>
        <span v-else>
          <vi-amount
            color="danger"
            :prefix="scope.row.wallet.currency.prefix"
            v-model="scope.row.wallet.balance"
          />
        </span>
      </template>
    </VCDataTable>
  </div>
</template>

<script>
import VCDataTable from "@leiweb/kernel-dashboard/src/controls/data/DataTable";
export default {
  name: "PageDashboardCustomerWallet",
  components: {
    VCDataTable,
  },
  data() {
    return {
      dtable: {
        url: "/kernel/enterprise/apis/data/customerWallet",
        orderBy: { name: "ID", type: "Desc" },
        params: { customerAgentSN: `${this.$route.params.sn}` },
        fields: [
          {
            name: "sn",
            type: "text",
            label: "订单号",
            table: { hidden: true },
          },

          // {
          //   name: "walletCurrencyName",
          //   source: "wallet.currency.name",
          //   type: "text",
          //   label: "币种",
          // },
          // {
          //   name: "walletBalance",
          //   source: "wallet.balance",
          //   type: "slot",
          //   label: "余额",
          // },
          // {
          //   name: "creatorName",
          //   source: "creator.name",
          //   type: "text",
          //   label: "操作人",
          // },
          // {
          //   name: "walletActiveTime",
          //   source: "wallet.activeTime",
          //   type: "date",
          //   label: "开通时间",
          // },
          // {
          //   name: "walletSN",
          //   source: "wallet.sn",
          //   type: "text",
          //   table: { hidden: true },
          // },
          // {
          //   name: "walletCurrencyPrefix",
          //   source: "wallet.currency.prefix",
          //   type: "text",
          //   table: { hidden: true },
          // },
        ],
        add: {
          enable: false,
        },
        edit: {
          enable: false,
        },
        // rowActions: [
        //   { name: "menu", icon: "fas:plus" },
        //   { name: "recharge", icon: "fas:clock" },
        //   { name: "base", icon: "fas:bars" },
        // ],
      },
    };
  },
  mounted() {
    // this.eCustomerList();
    // this.eCurrencyList();
  },
  methods: {
    eRowAction(action, row) {
      if (action.name == "menu") {
        this.$$.navigate.to({
          label: `线下代充`,
          path: `/shiyun/customer/account/${row.wallet.sn}/offline`,
        });
      }
      if (action.name == "base") {
        this.$$.navigate.to({
          label: `收支明细`,
          path: `/shiyun/customer/wallet/${row.wallet.sn}/flow`,
        });
      }
      if (action.name == "recharge") {
        this.$$.navigate.to({
          label: `充值记录`,
          path: `/shiyun/customer/wallet/${row.wallet.sn}/recharge`,
        });
      }
    },
    // eCustomerList() {
    //   this.$$.api.data
    //     .list("/shiyun/aliyun/apis/data/customer", {
    //       columns: ["userSN", "name"],
    //     })
    //     .then((res) => {
    //       let data = res.data.list;
    //       data.map((p) => {
    //         this.custmoerList.push({ label: p.name, value: p.userSN });
    //       });
    //     });
    // },
    // eCurrencyList() {
    //   this.$$.api.data
    //     .list("/kernel/transaction/apis/data/currency", {
    //       columns: ["code", "sn", "name"],
    //     })
    //     .then((res) => {
    //       let data = res.data.list;
    //       data.map((p) => {
    //         this.currencyList.push({
    //           label: `${p.name} (${p.code})`,
    //           value: p.sn,
    //         });
    //       });
    //     });
    // },
    // eFilter() {
    //   this.dtable.params = ["wallet.type == Debit"];
    //   if (!this.custmoerSN) {
    //     this.dtable.params = [];
    //     return;
    //   }
    //   if (this.custmoerSN == "all") {
    //     this.dtable.params = ["wallet.type == Debit"];
    //     return;
    //   }
    //   if (this.custmoerSN && !this.currencySN) {
    //     this.dtable.params.push(`userSN == ${this.custmoerSN}`);
    //   }
    //   this.dtable.params.push(`userSN == ${this.custmoerSN}`);
    // },
  },
};
</script>

<style lang="scss" scoped>
</style>